/**
 * Canonical `localStorage` / `sessionStorage` keys used as cross-flow markers.
 * Always import the constant — never inline the string — so a rename or
 * typo surfaces at the type level instead of silently breaking a branch.
 */
export const STORAGE_KEYS = {
    /**
     * Set by `ChangeDateContinueClickAction` and `UpgradeToPremiumContinueClickAction`
     * when entering a change-date / change-time exchange flow. Read by every
     * branch that needs to toggle change-date-specific math (per-leg Total
     * formula, addon carry-over, credit banner, "NEW" tag rule, payment
     * redirect gate). Cleared on entry to manage-seating, quick-exchange,
     * and on the payment-gateway callback.
     */
    CHANGE_DATE_FLOW: "isChangeDateFlow",
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
